import React, { useContext } from 'react';
import { ScrollView } from 'react-native';
import {
  NativeBaseProvider,
  useToast,
  VStack,
} from 'native-base';
import {
  Button, Dialog, Portal, TextInput,
} from 'react-native-paper';
import { useMutation } from '@apollo/client';
import { Formik } from 'formik';
import { date, object, string } from 'yup';
import { addYears } from 'date-fns';
import { DatePickerInput } from 'react-native-paper-dates';
import { ModalContext } from '../../context/ModalContext';
import { CreateSeason } from '../../gql/season/mutation';
import { FindManySeasons } from '../../gql/season/query';
import { styles } from '../../screens/Common.style';

function SeasonModal() {
  const { displayCreateSeasonModal, toggleCreateSeasonModal } = useContext(ModalContext);
  const [createSeason] = useMutation(CreateSeason);
  const toast = useToast();

  const validationSchema = object({
    name: string().required('Champ requis'),
    startDate: date()
      .required('Champ requis'),
    endDate: date()
      .required('Champ requis'),
  });

  return (
    <Dialog
      visible={displayCreateSeasonModal}
      dismissable
      onDismiss={toggleCreateSeasonModal}
    >
      <Dialog.Title>Créer une saison</Dialog.Title>
      <Dialog.Content>
        <Formik
          initialValues={{
            name: '',
            startDate: new Date(),
            endDate: addYears(new Date(), 1),
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            await createSeason({
              variables: {
                data: {
                  name: values.name,
                  startDate: values.startDate,
                  endDate: values.endDate,
                },
              },
              refetchQueries: [
                FindManySeasons,
                'findManySeasons',
              ],
            });
            toggleCreateSeasonModal();
            toast.show('Saison créée avec succès');
          }}
        >
          {({
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            values,
            errors,
            touched,
          }) => (
            <ScrollView>
              <VStack space={4}>
                <TextInput
                  label="Nom de la saison"
                  value={values.name}
                  onChangeText={handleChange('name')}
                  onBlur={handleBlur('name')}
                  error={touched.name && errors.name}
                  style={styles.whiteBackground}
                />
                <DatePickerInput
                  presentationStyle='pageSheet'
                  locale="fr"
                  label="Date de début"
                  value={values.startDate}
                  onChange={(d) => setFieldValue('startDate', d)}
                  inputMode="start"
                  style={styles.whiteBackground}
                />
                <DatePickerInput
                  presentationStyle='pageSheet'
                  locale="fr"
                  label="Date de fin"
                  value={values.endDate}
                  onChange={(d) => setFieldValue('endDate', d)}
                  inputMode="start"
                  style={styles.whiteBackground}
                />
                <Button onPress={handleSubmit}>Créer</Button>
              </VStack>
            </ScrollView>
          )}
        </Formik>
      </Dialog.Content>
    </Dialog>
  );
}

export default function CreateSeasonModal() {
  return (
    <Portal>
      <NativeBaseProvider>
        <SeasonModal />
      </NativeBaseProvider>
    </Portal>
  );
}
